import 'maxkir/common/listeners';
import '../shift_shift_item'

export interface ActionItem extends ShiftShiftItem {
    alias?: string
    tag?: string
    w?: number          // Relative weight of this item
}

type PreferredAction = string

interface ListActionsModel extends ShiftShiftModel {
    setPreferredActionsOrder(order: PreferredAction[]);
    getFoundItems(): ActionItem[];
}

let _current_text = null;
let _delayed_typing = null;
let _listeners = new maxkir.Listeners();

let _actions_items: ActionItem[] = [];
let _preferred_items_order: PreferredAction[] = [];
let _reset_selection: boolean = false;

let _all_actions_promise = null;
let _is_loading = false;

const process_text_changed = (newText) => {

    _is_loading = true;
    get_actions_data_promise(newText).then((items: ActionItem[]) => {
        _actions_items = _sort_items(items);
        _reset_selection = true;
        _is_loading = false;
        _listeners.notify_listeners_as_function();
    }, () => {
        _is_loading = false;
    });

}

const create_actions_data_promise = (searchValue: string): Promise<ActionItem[]> => {
    return new Promise(function(resolve, reject) {
        maxkir.AjaxRequest("/search/everywhere.json", {
            method: "get",
            parameters: "what=" + encodeURIComponent(searchValue),
            onSuccess: function(response) {
                resolve(response.responseJSON["commands"])
            },
            onComplete: reject
        });
    })
}

const get_actions_data_promise = function(searchValue): Promise<ActionItem[]> {

    maxkir.info("Getting actions data for " + searchValue);
    if (maxkir.is_testing()) {
        maxkir.info("Return test data for /search/everywhere.json");
        return maxkir._test_searchPromise;
    }

    if (!searchValue) {
        // Cache promise results
        _all_actions_promise = _all_actions_promise || create_actions_data_promise(searchValue);
        return _all_actions_promise;
    }
    return create_actions_data_promise(searchValue);
};

const _sort_items = function(items: ActionItem[]) {
    // Separator and ---more---
    const isSeparator = (item: string) => item.indexOf && item.indexOf("---") === 0;
    const separatorItem = (action_id: string) => ( {id: action_id, text: "", title: ""} )

    var onlyPreferred = _preferred_items_order.length > 1 && !has_filter() && items.length > _preferred_items_order.length;

    var preferred_items: ActionItem[] = [];
    var result_items: ActionItem[] = items;

    if (_preferred_items_order.length && !has_filter()) {

        var item_map = {}
        items.forEach(function (item) {
            item_map[item.id] = item;
        })

        for(var i = 0; i < _preferred_items_order.length; i ++) {
            var action_id = _preferred_items_order[i];
            if (item_map[action_id]) {
                preferred_items.push(item_map[action_id])
                delete item_map[action_id];
            }
            else if (isSeparator(action_id) && preferred_items.length &&
                (!isSeparator(preferred_items[preferred_items.length - 1].id) || action_id === '---more---')) {
                // Add separator item
                preferred_items.push(separatorItem(action_id))
            }
        }

        // Fill remaining items for sorting
        result_items = [];
        for(var key in item_map) {
            if (item_map.hasOwnProperty(key)) {
                result_items.push(item_map[key])
            }
        }
    }

    if (onlyPreferred) {
        result_items = preferred_items;
    }
    else {
        result_items = result_items.sort(function(a, b) {
            var w1 = a.w || 0;
            var w2 = b.w || 0;

            if (w1 === w2) {
                return a.text.localeCompare(b.text)
            }
            // if (a.id == 'unhoist' || b.id == 'unhoist') {
            //   console.warn(a, b, w1, w2);
            // }
            return w2 - w1;
        });

        result_items = preferred_items.concat(result_items);
    }


    var enabled = [];
    var disabled = [];

    result_items.forEach(function (item_data) {
        if (isSeparator(item_data.id) || cv_commands.can_run(item_data.id, item_data.tag)) {
            enabled.push(item_data);
        }
        else {
            disabled.push(item_data);
        }
    });
    if (enabled.length && disabled.length) {
        // Add a separator between enabled and disabled items
        return enabled.concat(separatorItem('---')).concat(disabled);
    }
    return enabled.concat(disabled);
};

const has_filter = () => model.getFilterTerms().length > 0

const model: ListActionsModel = {
    code: 'actions',

    getFilterTerms(): string[] {
        return !_current_text ? [] : _current_text.split(/ +/);
    },

    isLoading(): boolean {
        return _is_loading;
    },

    shouldResetSelection(): boolean {
        const res = _reset_selection;
        _reset_selection = false;
        return res;
    },

    onTextChanged(newText, delayProcessing: boolean) {
        _current_text = newText;
        if (!delayProcessing) {
            process_text_changed(_current_text);
            return
        }

        if (!_delayed_typing) {
            _delayed_typing = maxkir.delay_action(() => {
                process_text_changed(_current_text);
            }, 20);
        }
        _delayed_typing.start();
    },

    addDataAvailableCallback(callback) {
        _listeners.add_listener(callback)
    },

    removeDataAvailableCallback(callback) {
        _listeners.remove_listener(callback)
    },

    setPreferredActionsOrder(order) {
        _preferred_items_order = order
    },

    getFoundItems(): ActionItem[] {
        return _actions_items;
    },

    dispose() {
        _actions_items = [];
        _listeners.dispose();
    }


}

export default model;